import { Injectable } from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  /*  {
   id: 'navigation',
   title: 'Navigation',
   type: 'group',
   icon: 'icon-navigation',
   children: [
     {
       id: 'dashboard',
       title: 'Trang chủ',
       type: 'item',
       url: '/dashboard/default',
       icon: 'feather icon-home',
       classes: 'nav-item',
     }
   ]
 },   */

  //Long 7/4/2020
  {
    id: 'grhethong',
    title: 'Quản trị hệ thống',
    type: 'group',
    //icon: 'icon-pages',
    children: [
      {
        id: 'system',
        title: 'Cấu hình hệ thống',
        type: 'collapse',
        icon: 'feather icon-lock',
        children: [
          {
            id: 'sys_user',
            title: 'Người dùng',
            type: 'item',
            url: '/system/sysuser'
            /*         target: true, //mo thanh tab moi
                   breadcrumbs: false */
          },
          {
            id: 'sys_usergroup',
            title: 'Nhóm người dùng',
            type: 'item',
            url: '/system/sysusergroup'
          }/* ,
          {
            id: 'sys_role',
            title: 'Vai trò',
            type: 'item',
            url: '/system/sysrole'
          },
          {
            id: 'sys_function_group',
            title: 'Nhóm chức năng hệ thống',
            type: 'item',
            url: '/system/sysfunctiongroup'
          },
          {
            id: 'sys_function',
            title: 'Chức năng hệ thống',
            type: 'item',
            url: '/system/sysfunction'
          },
          {
            id: 'sys_user_permission',
            title: 'Phân quyền người dùng',
            type: 'item',
            url: '/system/sysuserpermission'
          },
          {
            id: 'sys_user_group_permission',
            title: 'Phân quyền nhóm người dùng',
            type: 'item',
            url: '/system/sysusergrouppermission'
          } */
        ]
      }
    ]
  },
  // End Long 7/4/2020
  {
    id: 'grqltt',
    title: 'Quản lý thông tin',
    type: 'group',
    //icon: 'icon-pages',
    children: [
      {
        id: 'danhmuc', //'basic',
        title: 'Danh mục',
        type: 'collapse',
        // type: 'group', icon: 'feather icon-box',
        icon: 'fas fa-list',
        children: [
          {
            id: 'donvi', //'button',
            title: 'Đơn vị',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/donvi' //edit thu de commit
          },
          {
            id: 'donvitructhuoc', //'button',
            title: 'Đơn vị trực thuộc',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/donvitructhuoc' //edit thu de commit
          },
          {
            id: 'qlttlinhvuc', //'button',
            title: 'Lĩnh vực',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/qlttlinhvuc' //edit thu de commit
          },
          {
            id: 'chuyende', //'badges',
            title: 'Chuyên đề',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/chuyende' //'/basic/badges'
          },
          {
            id: 'thutuc',
            title: 'Thủ tục',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/thutuc'
          }
          ,
          {
            id: 'dmhuyenthidadt',
            title: 'Huyện thị thành',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/dmhuyenthidadt'
          }
          ,
          {
            id: 'dmlinhvucdadt',
            title: 'Lĩnh vực dự án đầu tư',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/dmlinhvucdadt'
          }
          ,
          {
            id: 'dmnguonkinhphidadt',
            title: 'Nguồn kinh phí dự án đầu tư',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/dmnguonkinhphidadt'
          },
          {
            id: 'linhvucgopy', //'button',
            title: 'Lĩnh vực góp ý',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/linhvucgopy' //edit thu de commit
          },
          {
            id: 'dmloaidoituong', //'button',
            title: 'Loại đối tượng',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/dmloaidoituong' //edit thu de commit
          },
          {
            id: 'dmlanhdao', //'button',
            title: 'Lãnh đạo',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/dmlanhdao' //edit thu de commit
          }
          /*,
          {
            id: 'dmhinhthucguipakn', //'button',
            title: 'Hình thức gửi PAKN',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/hinhthucguipakn' //edit thu de commit
          }
          ,
          {
            id: 'dmlinhvucpakn', //'button',
            title: 'Lĩnh vực PAKN',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/linhvucpakn' //edit thu de commit
          }
          ,
          {
            id: 'dmphanloaipakn', //'button',
            title: 'Phân loại chủ đề PAKN',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/phanloaipakn' //edit thu de commit
          }

          ,{
            id: 'dmtinhthanh', //'button',
            title: 'Tỉnh thành',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/tinhthanh' //edit thu de commit
          }
          ,{
            id: 'dmhuyenthi', //'button',
            title: 'Quận, huyện',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/huyenthi' //edit thu de commit
          }
          ,{
            id: 'dmphuongxa', //'button',
            title: 'Phường, xã',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmuc/phuongxa' //edit thu de commit
          }*/
        ]

      },
      {
        id: 'cauhoithamdo', //'basic',
        title: 'Câu hỏi thăm dò',
        type: 'collapse',
        // type: 'group',
        icon: 'fas fa-check-square',
        children: [
          {
            id: 'cauhoi', //'button',
            title: 'Câu hỏi',
            type: 'item',
            classes: 'nav-item',
            url: '/cauhoi/cauhoi' //edit thu de commit
          },
          {
            id: 'thongke', //'button',
            title: 'Thống kê',
            type: 'item',
            classes: 'nav-item',
            url: '/cauhoi/thongke' //edit thu de commit
          }

        ]

      },
      {
        id: 'pakn',
        title: 'Phản ánh kiến nghị',
        type: 'collapse',
        icon: 'fas fa-pencil-alt',
        children: [
          {
            id: 'phananhkiennghi',
            title: 'Phản ánh kiến nghị',
            type: 'item',
            url: '/pakn/phananhkiennghi'
          },
          {
            id: 'gioithieu',
            title: 'Giới thiệu',
            type: 'item',
            url: '/pakn/gioithieu'
          },
          {
            id: 'huongdan',
            title: 'Hướng dẫn',
            type: 'item',
            url: '/pakn/huongdan'
          }
          ,
          {
            id: 'thongtinluuy',
            title: 'Thông tin lưu ý',
            type: 'item',
            url: '/pakn/thongtinluuy'
          }
        ]
      },
      {
        id: 'dmtthc',
        title: 'Thủ tục hành chính',
        type: 'item',
        icon: 'fas fa-file-alt',
        url: '/dmtthc/thutuchanhchinh',

      },
      /*{
        id: 'giaiquyetdonthukntc',
        title: 'Đơn thư khiếu nại tố cáo',
        type: 'item',
        icon: 'far fa-envelope',
        url: '/gqdtkntc/giaiquyetdonthukntc'
      },
      {
        id: 'duankeugoidautu',
        title: 'Dự án kêu gọi đầu tư',
        type: 'item',
        icon: 'fas fa-hand-holding-usd',
        url: '/duankeugoi/duankeugoidautu'
      },
      {
        id: 'tiepcongdan',
        title: 'Lịch tiếp công dân',
        type: 'item',
        icon: 'fas fa-user-clock',
        url: '/qltttcd/tiepcongdan'
      },
      {
        id: 'qlttlh',
        title: 'Quản lý lịch họp',
        type: 'item',
        icon: 'fas fa-users',
        url: '/qlttlh/lichhop'
      }
      {
        id: 'qlttlh', //'basic',
        title: 'Quản lý lịch họp',
        type: 'collapse',
        // type: 'group', icon: 'feather icon-box',
        icon: 'fas fa-users',
        children: [
          {
            id: 'qlttlhview', //'button',
            title: 'Quản lý lịch họp',
            type: 'item',
            classes: 'nav-item',
            url: '/qlttlh/lichhop' //edit thu de commit
          },
          {
            id: 'qlttlhadd',
            title: 'Nhập lịch họp',
            type: 'item',
            classes: 'nav-item',
            url: '/qlttlh/nhaplichhop'
          }
        ]

      },*/
      {
        id: 'lienhe',
        title: 'Liên hệ',
        type: 'item',
        icon: 'fas fa-address-card',
        url: '/lienhe/lienhe'
      },
      {
        id: 'qltthoidap',
        title: 'Góp ý',
        type: 'item',
        icon: 'fas fa-file-signature', //<i class="fas fa-file-invoice-dollar"></i>
        url: '/qltthoidap/hoidap'
      },
      {
        id: 'hoidaptructuyen',
        title: 'Hỏi đáp trực tuyến',
        type: 'item',
        icon: 'fas fa-question',
        url: '/hoidaptt/hoidaptructuyen'
      },
     /*  {
        id: 'qlttcongkhaingansach',
        title: 'Công khai ngân sách',
        type: 'item',
        icon: 'fas fa-file-invoice-dollar',
        url: '/qlttcongkhaingansach/congkhaingansach'
      }, */
      {
        id: 'qlttckns', //'basic',
        title: 'Công khai ngân sách',
        type: 'collapse',
        // type: 'group', icon: 'feather icon-box',
        icon: 'fas fa-file-invoice-dollar',
        children: [
          {
            id: 'cauhinhckns', //'button',
            title: 'Cấu hình',
            type: 'item',
            classes: 'nav-item',
            url: '/qlttcongkhaingansach/cauhinh' //edit thu de commit
          },
          {
            id: 'qlttcongkhaingansach',
            title: 'Công khai ngân sách',
            type: 'item',
            classes: 'nav-item',
            url: '/qlttcongkhaingansach/congkhaingansach'
          }
        ]

      }    
    ]
  },
  {
    id: 'grqlvb',
    title: 'Quản lý văn bản',
    type: 'group',
    //icon: 'icon-pages',
    children: [
      {
        id: 'danhmucvb', //'basic',
        title: 'Danh mục',
        type: 'collapse',
        // type: 'group', icon: 'feather icon-box',
        icon: 'fas fa-list',
        children: [
          {
            id: 'coquanbanhanhvb', //'button',
            title: 'Cơ quan ban hành',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucvb/coquanbanhanhvb' //edit thu de commit
          },
          {
            id: 'linhvucvb', //'button',
            title: 'Lĩnh vực',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucvb/linhvucvb' //edit thu de commit
          },
          {
            id: 'linhvucvbchitiet', //'button',
            title: 'Lĩnh vực chi tiết',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucvb/linhvucvbchitiet' //edit thu de commit
          },
          {
            id: 'loaivanbanvb', //'button',
            title: 'Loại văn bản',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucvb/loaivanbanvb' //edit thu de commit
          },
          {
            id: 'nguoikyvb', //'badges',
            title: 'Người ký',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucvb/nguoikyvb' //'/basic/badges'
          }
        ]

      },
      {
        id: 'qlvanban', //'basic',
        title: 'Quản lý văn bản',
        type: 'collapse',
        // type: 'group', icon: 'feather icon-box',
        icon: 'fas fa-file-alt',
        children: [
          {
            id: 'nhapvanban', //'button',
            title: 'Quản lý văn bản',
            type: 'item',
            classes: 'nav-item',
            url: '/qlvanban/nhapvanban' //edit thu de commit
          }/* ,
          {
            id: 'duthaovanban',
            title: 'Lấy ý kiến văn bản',
            type: 'item',
            classes: 'nav-item',
            url: '/qlvanban/duthaovanban'
          } */
          ,
          {
            id: 'duthaovanbandanglayykien',
            title: 'Văn bản đang lấy ý kiến',
            type: 'item',
            classes: 'nav-item',
            url: '/qlvanban/duthaovanban/danglayykien'
          }
          ,
          {
            id: 'duthaovanbandalayykien',
            title: 'Văn bản đã lấy ý kiến',
            type: 'item',
            classes: 'nav-item',
            url: '/qlvanban/duthaovanban/dalayykien'
          }
        ]

      },
      {
        id: 'diendan',
        title: 'Diễn đàn cử tri',
        type: 'item',
        icon: 'fas fa-address-card',
        url: '/diendan/diendan'
      }
    ]
  }/*,
  {
    id: 'grthongtindetai',
    title: 'Nhiệm vụ KH&CN',
    type: 'group',
    children: [
      {
        id: 'danhmucdetai', //'basic',
        title: 'Danh mục',
        type: 'collapse',
        icon: 'fas fa-list',
        children: [
          {
            id: 'linhvucdetai',
            title: 'Lĩnh vực',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucdetai/linhvuc'
          },
          {
            id: 'coquanchutri',
            title: 'Cơ quan chủ trì',
            type: 'item',
            classes: 'nav-item',
            url: '/danhmucdetai/coquanchutri'
          }
        ]
      },
      {
        id: 'thongtindetai', //'button',
        title: 'Thông tin nhiệm vụ KH&CN',
        type: 'item',
        icon: 'fas fa-file-alt',
        classes: 'nav-item',
        url: '/thongtindetai/detai'

      }
    ]
  }*/
  
];

@Injectable()
export class NavigationItem {
  get() {
    return NavigationItems;
  }
}
